import { makeStyles } from '@material-ui/core/styles';
import { red } from 'styles/abstract/variables';

export const makeErrorPanelStyles = makeStyles({
    errorPanel: {
        color: red,
        display: 'flex',
        fontSize: '0.9rem',
        fontWeight: 600,
        margin: '0.25rem 0 0',
    },
});
